import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';

import {
	setModoTelaEvento, initFormEvento
} from './embalagemViagemActions';

class EmbalagemViagemEventoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>

						<Row>
							<Field
								name='id_tipo'
								component={Select}
								options={this.props.listaEventoTipo}
								label='Evento'
								cols='12 12 12 12'
								placeholder='Selecione o evento'
								readOnly={readOnly} />

							<Field
								name='datahora_evento'
								component={LabelAndInputMask}
								label='Data/Hora' placeholder='Informe a data e hora do evento'
								cols='12 6 4 4'
								mask='99/99/9999 99:99'
								readOnly={readOnly} />

							<Field
								name='cavalo'
								component={LabelAndInput}
								label='Cavalo'
								placeholder='Informe o cavalo'
								cols='12 6 4 4'
								readOnly={readOnly} />

							<Field
								name='carretas'
								component={LabelAndInput}
								label='Carretas'
								placeholder='Informe as carretas'
								cols='12 6 4 4'
								readOnly={readOnly} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTelaEvento('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
        )
    }

}

EmbalagemViagemEventoForm = reduxForm({form: 'embalagemViagemEventoForm', destroyOnUnmount: false})(EmbalagemViagemEventoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('embalagemViagemEventoForm')(state),
	formularioViagemValues: getFormValues('embalagemViagemForm')(state),
	listaEventoTipo: state.embalagemViagem.listaEventoTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTelaEvento, initFormEvento
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(EmbalagemViagemEventoForm);
